import { useQuery } from '@tanstack/react-query';
import { presetQueries } from './queries';

export const usePresets = () => useQuery(presetQueries.list());
